import Modal from "./../../elements/Modal";
import { ReactComponent as CloseIcon } from "../../assets/icons/close.svg";
import { ReactComponent as ErrorIcon } from "../../assets/icons/error.svg";

const ErrorModal = ({ handleClose, setErrorModal,setErrorMessage, errorMessage }) => {

  return (
    <Modal
      headerActions={
        <CloseIcon
          onClick={() => {
            setErrorMessage(null);
            setErrorModal(false);
          }}
          className="clickable"
        />
      }
      onClose={() => console.log("Modal Closed")}
    >
      <div  style={{"display": "flex" , "flex-direction": "column", "align-items": "center", "gap": "25px"}}>
      <span className="modalBodyHead">
        <ErrorIcon width={80} height={80}/>
      </span>
      <span className="modalBodyHead">{errorMessage}</span>
      </div>
    </Modal>
  );
};

export default ErrorModal;
